/* eslint-disable react/no-unescaped-entities */
import { Star } from "lucide-react";

const items = [
  {
    quote:
      "I have PCOS. Every other app just told me to eat less. SmartPlaite actually noticed my sleep was wrecking my insulin — MIQ jumped 22 points in 6 weeks.",
    name: "Maya R.",
    meta: "PCOS · 6 weeks in",
    img: "https://images.pexels.com/photos/36519667/pexels-photo-36519667.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=200&w=200",
  },
  {
    quote:
      "Marathon block + a full-time job. The Weekly Brief is the only reason I hit a 7-minute PR. It saw my recovery dipping before I felt it.",
    name: "Derek O.",
    meta: "Endurance athlete · sub-3 marathoner",
    img: "https://images.unsplash.com/photo-1549505415-e16dbd446231?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwzfHxhdGhsZXRlJTIwcG9ydHJhaXQlMjBkYXJrfGVufDB8fHx8MTc4MDQ1ODUxMHww&ixlib=rb-4.1.0&q=85&w=200",
  },
  {
    quote:
      "My doctor flagged stage-1 hypertension last year. With Genius I'm tracking peptides, sleep, sodium — MIQ in the 80s, BP back to normal in 4 months.",
    name: "James T.",
    meta: "Longevity · age 54",
    img: "https://images.pexels.com/photos/10341386/pexels-photo-10341386.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=200&w=200",
  },
];

export default function Testimonials() {
  return (
    <section data-testid="testimonials-section" className="relative py-28 md:py-36">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl">
          <div className="text-[11px] uppercase tracking-[0.24em] text-brand-accent font-bold mb-5">From real users</div>
          <h2 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[1.02]">
            Every goal. Every body. <span className="text-gradient-hero">Same engine.</span>
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {items.map((t, i) => (
            <figure key={t.name} data-testid={`testimonial-${i + 1}`} className="glass rounded-3xl p-7 flex flex-col">
              <div className="flex items-center gap-1 mb-5">
                {[...Array(5)].map((_, idx) => (
                  <Star key={idx} className="w-3.5 h-3.5 fill-brand-accent text-brand-accent" />
                ))}
              </div>
              <blockquote className="text-white/85 text-base leading-relaxed font-light">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-7 flex items-center gap-3">
                <img src={t.img} alt={t.name} className="w-11 h-11 rounded-full object-cover border border-white/10" loading="lazy" />
                <div>
                  <div className="font-display font-semibold text-sm">{t.name}</div>
                  <div className="text-xs text-white/45">{t.meta}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
